import { render, staticRenderFns } from "./ShortcutKey.vue?vue&type=template&id=f0edb20c&scoped=true"
import script from "./ShortcutKey.vue?vue&type=script&lang=js"
export * from "./ShortcutKey.vue?vue&type=script&lang=js"
import style0 from "./ShortcutKey.vue?vue&type=style&index=0&id=f0edb20c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0edb20c",
  null
  
)

export default component.exports